import { commonFilter } from './filter';

export default {
  pageName: 'feedsPrivateDiscord',
  pageId: '20028',
  pagePath: '/opinion/privateDiscord',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    C_keyword: {
      buttonId: '200280',
    },
    GPT_Get_Btn: {
      buttonId: '2002801',
    },
    GPT_Confirm: {
      buttonId: '2002802',
    },
    ...commonFilter,
  },
};
